<template>
  <v-container class="fill-height logout-page" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5" lg="4">
        <v-card class="pa-8 text-center" elevation="2" rounded="lg">
          <v-img
            src="/images/e360_Logo.svg"
            max-width="160"
            class="mx-auto mb-8"
          />

          <v-icon
            icon="mdi-logout"
            size="56"
            color="primary"
            class="mb-4"
          />

          <h1 class="text-h5 font-weight-bold text-primary mb-2">
            You've been signed out
          </h1>

          <p class="text-body-2 text-medium-emphasis mb-8">
            Your session has ended. Sign in again to continue.
          </p>

          <v-btn
            color="primary"
            size="large"
            block
            rounded="lg"
            prepend-icon="mdi-login"
            @click="signIn"
          >
            Sign In
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';

const store = useStore();

function signIn() {
  store.dispatch('session/login');
}
</script>

<style scoped>
.logout-page {
  background-color: rgb(var(--v-theme-background));
  min-height: 100%;
}
</style>
